import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAdminPaymentSystemsDetailsListRecord } from '../types';
import {
  ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_API_URL,
  ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_QUERY_KEY,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
} from '../constants';
import { EPaymentSystemsTableListType } from '../types';

export default function useAdminPaymentSystemsListQuery(
  tableState: Ref<ITableState>,
  tableType: Ref<EPaymentSystemsTableListType>,
): IContextQueryResult<ITableDataResponse<IAdminPaymentSystemsDetailsListRecord>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAdminPaymentSystemsDetailsListRecord>>({
    queryKey: [ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_QUERY_KEY, tableState, tableType],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAdminPaymentSystemsDetailsListRecord>>(
      ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: tableType.value === EPaymentSystemsTableListType.PENDING_LIST
          ? PAYMENT_SYSTEM_DETAILS_PERMISSIONS.PENDING_LIST_SHOW
          : PAYMENT_SYSTEM_DETAILS_PERMISSIONS.HISTORY_LIST_SHOW,
        urlParams: {
          tableType: tableType.value,
        },
      },
    ),
    placeholderData: keepPreviousData,
  });
}
